<template>
  <div class="d-flex">

    <ScenarioInput 
      :disabled="isLimitedForcast"
      class="mr-3"
      scenario="model"
      :options="models" />
    <ScenarioInput 
      class="mr-3"
      scenario="year"
      :options="availableYears" />
    <ScenarioInput
      :disabled="isLimitedForcast"
      class="mr-3"
      scenario="access"
      :options="access"/>
    <ScenarioInput 
      class="mr-3"
      scenario="forecast"
      :options="forcastOptions" />

  </div>
</template>

<script>
import ScenarioInput from '@/components/navbar/ScenarioInput'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ScenarioInputs',
  components: { 
    ScenarioInput
  },
  computed: {
    /**
     * The scenario options for years & models are part of the municipality configuration 
     */
    ...mapGetters('config', [
      'years', 'models', 'forcastOptions'
    ]),
    ...mapGetters('scenarios', [
      'year', 'model', 'forecast'
    ]),
    /**
     * The scenario options for access & forecast are fixed
     */
    access() {
      return [
        {
          value: 'public',
          text: 'Publiek'
        },
        {
          value: 'private',
          text: 'Privaat'
        }
      ]
    },
    // For these forecast variations we only have data for these 3 years, and no distinction between public / private or data models
    isLimitedForcast() {
      return ['carsharing', 'logistics', 'taxis'].includes(this.forecast)
    },
    
    availableYears() { 
      if (this.forecast === 'fastcharge') {
        return [2025, 2030, 2035].filter(year => this.years.includes(year))
      }
      else if (this.isLimitedForcast) { // 2022, 
        return [2022, 2025, 2030].filter(year => this.years.includes(year))
      }
      return this.years
    }
  },
  watch: {
    /**
     * Track changes to the scenario options that can change per municipality
     *  If the active option is no longer available, select the first available option
     */
    availableYears() {
      this.checkYearOptions()
    },
    models() {
      this.checkModelOptions()
    },
    forcastOptions() {
      this.checkForecastOptions()
    }
  },
  created() {
    this.checkYearOptions()
    this.checkModelOptions()
    this.checkForecastOptions()
  },
  methods: {
    ...mapMutations('scenarios', [
      'setYear', 'setModel', 'setForecast'
    ]),
    /**
     * If the selected option is (no longer) available, select the first available option
     */
    checkYearOptions() {
      if (! this.availableYears.includes(this.year)) {
        this.setYear({
          scenario: this.availableYears[0] || null
        })
      }
    },
    /**
     * If the selected option is (no longer) available, select the first available option
     */
    checkModelOptions() {
      if (! this.models.includes(this.model)) {
        this.setModel({
          scenario: this.models[0] || null
        })
      }
    },
    /**
     * If the selected option is (no longer) available, select the first available option
     */
    checkForecastOptions() {
      if (! this.forcastOptions.includes(this.forecast)) {
        this.setForecast({
          scenario: this.forcastOptions[0].value || null
        })
      }
    }
  }
}
</script>